/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import helpers from './../../../../utils/helpers';
import { mapGetters, mapMutations } from 'vuex';
import purchaseService from './../../../../services/purchase';
import purchaseStatusService from './../../../../services/purchaseStatus';
import purchaseTransformer from './../../../../transformers/purchase';
import warehouseService from './../../../../services/warehouse';
import clientService from './../../../../services/client';
import Forms from './../../../../utils/forms/forms';
import productService from './../../../../services/product';
import previewMessage from './../../../../components/previewMessage/previewMessage.vue';
import purchaseRecieve from './../../../../components/purchaseRecieve/purchaseRecieve.vue';
import store from './../../../../store';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        purchaseNumber: {
          value: '',
          type: 'text',
        },
        comments: {
          value: '',
          type: 'text',
        },
        warehouseId: {
          value: '',
          type: 'select',
        },
        supplierId: {
          value: '',
          type: 'select',
        },
        expectedDeliveryDate: {
          value: '',
          type: 'date',
        },
      }),
      loading: true,
      tabIndex: 'first',
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        qty: {
          value: '0',
          type: 'text',
        },
        purchasePrice: {
          value: '0',
          type: 'text',
        },
        costPrice: {
          value: '0',
          type: 'text',
        },
      },
      currentPurchase: {
        purchaseStatus: {
          name: '',
        },
      },
      hashId: '',
      dropdownState: false,
      dropdownState2: false,
      userLang: 'no',
      server: {
        url: '',
      },
    };
  },

  computed: {
    ...mapGetters({
      currentStockProducts: 'currentStockProductsCustom',
      warehouses: 'allWarehouses',
      suppliers: 'allClientOptions',
      status: 'purchaseStatuses',
    }),

    purchaseTitle() {
      if (this.currentPurchase.purchaseStatus.name === 'pending') {
        return 'pending_external';
      }
      return this.currentPurchase.purchaseStatus.name.replace(/ /g, '_');
    },

    showDraft() {
      return this.currentPurchase.purchaseStatus.name === 'draft';
    },

    showCancelPurchase() {
      return this.currentPurchase.purchaseStatus.name === 'progress' ||
      this.currentPurchase.purchaseStatus.name === 'draft';
    },

    showSave() {
      return this.currentPurchase.purchaseStatus.name !== 'pending' &&
      this.currentPurchase.purchaseStatus.name !== 'pending external' &&
      this.currentPurchase.purchaseStatus.name !== 'progress' &&
      this.currentPurchase.purchaseStatus.name !== 'done';
    },

    showComplete() {
      return this.currentPurchase.purchaseStatus.name !== 'pending' &&
      this.currentPurchase.purchaseStatus.name !== 'pending external' &&
      this.currentPurchase.purchaseStatus.name !== 'done' &&
      this.currentPurchase.purchaseStatus.name !== 'draft' &&
      this.currentPurchase.purchaseStatus.name !== '';
    },

    isDisableForm() {
      return this.currentPurchase.purchaseStatus.name === 'pending external' || this.currentPurchase.purchaseStatus.name === 'done';
    },

    isSharedToYou() {
      const data = this.warehouses.items.filter(item => item.id === this.formBasicInformation.warehouseId);
      if (data.length > 0) {
        return data[0].isSharedToYou;
      }
      return false;
    },
  },

  watch: {
    warehouses(warehouses) {
      this.formBasicInformation.setOptions('warehouseId', warehouses.items);
    },

    status(status) {
      this.formBasicInformation.setOptions('status', status);
    },

    'formBasicInformation.warehouseId': function (warehouseId) {
      store.dispatch('setStockSelectedWarehouse', warehouseId);
    },

    suppliers(suppliers) {
      this.formBasicInformation.setOptions('supplierId', suppliers.map(c => ({ id: c.id, name: c.companyName || `${c.firstName} ${c.lastName}` })));
    },
  },

  created() {
     // close dropdown if click outside
    const self = this;
    window.addEventListener('click', (e) => {
      if (helpers.closeDropdown(e, self.dropdownState) === false) self.dropdownState = false;
      if (helpers.closeDropdown(e, self.dropdownState2) === false) self.dropdownState2 = false;
    });

    this.loading = false;
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalSize: 'SET_MODAL_SIZE',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING',
    }),

    // pendingExternal() {
    //   purchaseService.markAsPendingExternal(this.$route.params.id)
    //     .then(() => {
    //       this.$message({
    //         message: this.$t('static.purchase.pending.success'),
    //         type: 'success',
    //       });
    //       this.$router.push({
    //         name: 'inventory.purchase.index',
    //       });
    //     });
    // },

    updateDraft() {
      this.store('draft');
    },

    update() {
      this.store('pending');
    },

    cancelPurchase() {
      purchaseService.markAsCancel(this.$route.params.id)
        .then(() => {
          this.$message({
            message: this.$t('static.purchase.cancel.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.purchase.index',
          });
        });
    },

    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },
    /**
     * Activates the modal
     */
    activateModal() {
      this.setModalContent(() => purchaseRecieve);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },
    /**
     * Method to store the client
     */
    store(status = 'progress') {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = purchaseTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );
      let request = null;
      if (status === 'draft') {
        request = purchaseService.updateDraft(this.$route.params.id, client);
      } else if (status === 'pending' || status === 'progress') {
        client.status = status;
        request = purchaseService.update(this.$route.params.id, client);
      } else {
        request = purchaseService.store({ purchaseId: this.$route.params.id });
      }
      request.then(() => {
          this.$message({
            message: this.$t('static.purchase.update.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.purchase.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    markAsDone() {
      this.activateModal();
      /* this.loading = false;
      this.formBasicInformation.loading = true;
      const client = purchaseTransformer.send(
        Object.assign({}, this.formBasicInformation.data(),{ products:this.currentStockProducts })
      );
      purchaseService.markAsDone(this.$route.params.id, client)
      .then(() => {
        this.$message({
          message: this.$t('static.purchase.update.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'inventory.purchase.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formBasicInformation.recordErrors(errors);
      });*/
    },

    previewSendDocument() {
      const tempContact = [];
      const warehouseContact = this.currentPurchase &&
        this.currentPurchase.warehouse &&
        this.currentPurchase.warehouse.contact ? this.currentPurchase.warehouse.contact : null;

      if (warehouseContact && typeof warehouseContact.email !== 'undefined' && warehouseContact.email !== '') {
        tempContact.push({
          id: 0,
          email: warehouseContact.email,
          first_name: warehouseContact.firstName || '',
          last_name: warehouseContact.lastName || '',
          contact_types: [{ name: 'Primary' }],
        });
      }

      const supplierContact = this.currentPurchase &&
        this.currentPurchase.supplier &&
        this.currentPurchase.supplier.contact ? this.currentPurchase.supplier.contact : null;

      if (supplierContact && typeof supplierContact.email !== 'undefined' && supplierContact.email !== '') {
        const supplierName = (this.currentPurchase && this.currentPurchase.supplier && this.currentPurchase.supplier.name)
          ? this.currentPurchase.supplier.name
          : '';
        tempContact.push({
          id: 1,
          email: supplierContact.email,
          first_name: supplierName,
          last_name: '',
          contact_types: [{ name: 'Primary' }],
        });
      }

      purchaseService.showPurchaseEmailInformation(this.$route.params.id)
        .then((purchaseEmailInformation) => {
          this.setModalContent(() => previewMessage);
          this.setModalSize('full');
          this.setModalProps({
            isEmailInput: true,
            isMultiSelected: true,
            contacts: (tempContact.length > 0) ? tempContact : null,
            message: purchaseEmailInformation.message,
            subject: purchaseEmailInformation.title,
            // userEmail: purchaseEmailInformation.userEmail,
            notes: '',
            ccEmail: [purchaseEmailInformation.userEmail],
            // cc: true,
            headerTexts: [
              `${this.$t('static.bills.edit.from')}: ${purchaseEmailInformation.fromName} <${purchaseEmailInformation.fromEmail}>`,
            ],
            attachments: [{
              attachmentName: purchaseEmailInformation.attachmentName,
              action: this.showPurchase,
            }],
            buttons: [{
              name: this.$t('button.cancel'),
              action: this.cancelModal,
              title: this.$t('button.cancel'),
            },
            {
              name: (this.isPending ? this.$t('button.send') : this.$t('button.resend')),
              action: this.sendPurchase,
              title: (this.isPending ? this.$t('button.send') : this.$t('button.resend')),
            },
            ],
          });
          this.toggleModal(true);
        })
        .catch(() => {
          // Could not predict how this email will be sent.
          // Show some handling
        });
    },

    /**
     * Send the invoice to the client email.
     */
    sendPurchase(ev, test = false) {
      this.sendLoading = true;
      this.setModalButtonLoading(true);
      purchaseService.send(
          store.state.route.params.id, {
            email_to: store.state.modal.modalProps.email_to,
            email_cc: store.state.modal.modalProps.email_cc,
            message: store.state.modal.modalProps.message,
            subject: store.state.modal.modalProps.subject,
            // cc: store.state.modal.modalProps.cc,
            notes: store.state.modal.modalProps.notes,
            test,
          })
        .then(() => {
          this.toggleModal(false);
          this.sendLoading = false;
          this.setModalButtonLoading(false);
          purchaseService.show(store.state.route.params.id);
          this.$message({
            showClose: true,
            message: this.$t('static.purchase.edit.sendPurchaseSuccess'),
            type: 'success',
          });
        }).catch(() => {
          this.toggleModal(false);
          this.sendLoading = false;
          this.setModalButtonLoading(false);
          this.$message({
            showClose: true,
            message: this.$t('static.purchase.edit.sendPurchaseError'),
            type: 'error',
          });
        });
    },

    toggleDropdown() {
      this.dropdownState = !this.dropdownState;
      if (this.dropdownState) {
        this.dropdownState2 = false;
      }
    },

    toggleDropdown2() {
      this.dropdownState2 = !this.dropdownState2;
      if (this.dropdownState2) {
        this.dropdownState = false;
      }
    },

    sendTestPurchase(ev) {
      this.sendPurchase(ev, true);
    },

    showPurchase() {
      purchaseService.showPdf(this.hashId, this.userLang);
    },

    downloadPurchase() {
      purchaseService.download(this.hashId, this.userLang);
    },

    /**
     * Cancel modal trigger
     */
    cancelModal() {
      this.toggleModal(false);
    },

     /**
     * Check if it is still pending.
     */
    isPending() {
      return this.currentPurchase.purchaseStatus === 'Pending';
    },

    markAsDraft() {
      this.loading = false;
      // this.formBasicInformation.loading = true;
      const client = purchaseTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );
      purchaseService.saveAsDraft(this.$route.params.id, client)
        .then(() => {
          this.$message({
            message: this.$t('static.purchase.update.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.purchase.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },
  },
  mounted() {
    store.dispatch('allCurrentStockProductsCustom', []);
    Promise.all([
      purchaseService.show(this.$route.params.id),
      warehouseService.all(),
      purchaseStatusService.all(),
      clientService.allOptions('&filter=supplier'),
    ]).then((data) => {
      this.hashId = data[0].hashId;
      this.userLang = data[0].userLang;
      this.currentPurchase = data[0];
      this.formBasicInformation.assignData(this.currentPurchase);
    });
  },
  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VMessage: require('./../../../../components/form/message/message.vue'),
    VProductsTable: require('./../../../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/purchase/edit/edit.js